import * as R from "ramda";
import { mapToObjectDDL } from "../../../common/mapper";

export const constructDataDetailOtherItems = (data) => {
  return data
    .filter((item) => R.equals(item.saved, true))
    .map((item) => {
      return {
        otherCode: item.kodeotheritem ? item.kodeotheritem.value : null,
        total: Number(item.jumlah),
        idLocator: item.kodeLocation ? item.kodeLocation.value : null,
        barcode: item.qrotheritem ? item.qrotheritem : item.barcode,
        id: item.id || 88,
      };
    });
};

export const constructQR = (data) => {
  return data
    .filter((item) => R.equals(item.saved, true))
    .map((item) => {
      return {
        itemName: item.giftDTO?.nameHadiah,
        qrCode: item.giftBarcodeEncrypted,
        qrCodeRaw: item.giftBarcode,
      };
    });
};

export const validateDataTable = (list) => {
  const errors = [];
  console.log(list);
  const fieldsToValidate = ["locator", "kodeHadiah", "jumlah", "saved"];
  if (list.length === 0) {
    errors.push("Data detail harus diisi");
  }

  list.forEach((obj, index) => {
    const objErrors = {};

    fieldsToValidate.forEach((field) => {
      const value = obj[field];

      if (typeof value === "object" && value !== null) {
        if (!value.value || value.value === "") {
          objErrors[field] = `${field} cannot be empty or null`;
        }
      } else if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === false
      ) {
        objErrors[field] = `${field} cannot be empty or null`;
      }
    });

    const jumlah = Number(obj["jumlah"]);
    if (!R.isNil(jumlah)) {
      if (isNaN(jumlah) || jumlah < 1) {
        objErrors["jumlah"] = "jumlah must be greater than 0";
      }
    }

    if (Object.keys(objErrors).length > 0) {
      errors.push({ index, errors: objErrors });
    }
  });

  if (errors.length > 0) {
    return false;
  }

  return true;
};

export const contructPayloadSubmit = (data) => {
  return {
    kodeCabang: data?.kodeCabang?.value,
    spbhNo: data?.spbhNo || null,
    spbhDate: data?.spbhDate,
    spbmNo: data?.spbmNo,
    spbmDate: data?.spbmDate,
    slNo: data?.slNo,
    slDate: data?.slDate,
    supplier: data?.idSupplier?.value,
    noPolKendaraan: data?.noPolKendaraan,
    supplierExpedition: data?.idSupplierExpedisi?.value,
    notes: data?.note,
    detail: data.dataTable.map((item) => ({
      id: item?.id || null,
      idReceivingGift: item?.idReceivingGift || null,
      giftCode: item.kodeHadiah?.value,
      giftName: item?.namaHadiah,
      giftCategory: item?.kategori,
      satuan: item?.satuan,
      idLocator: item?.locator?.value,
      total: Number(item?.jumlah),
      qr: !!item?.kodeHadiah?.qrHadiah,
    })),
  };
};

export const getSupplierExpOptions = (data) => {
  return data.map((item) => {
    return {
      value: item.supplierCode,
      label: item.supplierCode,
      name: item.supplierName,
    };
  });
};

export const constructDataDetail = ({ data, setData }) => {
  setData("id", data?.id);
  setData("spbhNo", data?.spbhNo);
  setData("spbhDate", data?.spbhDate);
  setData("spbmNo", data?.spbmNo);
  setData("spbmDate", data?.spbmDate);
  setData("slNo", data?.slNo);
  setData("slDate", data?.slDate);
  setData("noPolKendaraan", data?.noPolKendaraan);
  setData("note", data?.notes);
  setData("total", data?.total);

  const supplier = data?.supplier;
  setData(
    "idSupplier",
    supplier
      ? mapToObjectDDL(supplier.supplierName, supplier.supplierCode)
      : null
  );

  const supplierExp = data?.supplierExpedition;
  setData(
    "idSupplierExpedisi",
    supplierExp
      ? {
          value: supplierExp.supplierCode,
          label: supplierExp.supplierCode,
          name: supplierExp.supplierName,
        }
      : null
  );

  const dataNonQR = data?.listNonQr.map((item) => ({
    ...item,
    kodeHadiah: item.giftDTO?.kodeHadiah,
    namaHadiah: item.giftDTO?.nameHadiah,
    kategori: item.giftDTO?.categoryDTO?.value,
    jumlah: item?.total,
    satuan: item.giftDTO?.satuanDTO?.value,
    locator: item.locator?.nameLocation,
    saved: true,
  }));

  console.log(data?.detail,'data?.detail')
  const dataQR = data?.listQr.map((item) => ({
    ...item,
    kodeHadiah: item.giftDTO?.kodeHadiah,
    namaHadiah: item.giftDTO?.nameHadiah,
    kategori: item.giftDTO?.categoryDTO?.value,
    qrcode: item?.giftBarcode,
    satuan: item.giftDTO?.satuanDTO?.value,
    locator: item.locator?.nameLocation,
    numbersOfPrint: item?.numberOfPrints || 0,
    saved: true,
  }));

  const dataDetail = data?.detail?.map((item) => ({
    kodeHadiah: {
      label: item.giftDTO?.kodeHadiah,
      value: item.giftDTO?.kodeHadiah,
      qrHadiah: item.giftDTO?.qrHadiah,
    },
    namaHadiah: item.giftDTO?.nameHadiah,
    kategori: item.giftDTO?.categoryDTO?.value,
    jumlah: item?.total,
    satuan: item.giftDTO?.satuanDTO?.value,
    locator: {
      label: item.locator?.nameLocation,
      value: item.locator?.kodeLocation,
      kodeCabang: item.locator?.kodeCabang,
    },
    numbersOfPrint: item?.numbersOfPrint || 0,
    idReceivingGift: data?.id,
    checkEdit: item?.checkEdit,
    id: item?.id,
    saved: true,
  }));

  setData("noQrGift", dataNonQR);
  setData("qrGift", dataQR);

  return {
    dataNonQr: dataNonQR || [],
    dataQr: dataQR || [],
    dataDetail: dataDetail || [],
    dataHeader: {
      id: data?.id,
      spbhNo: data?.spbhNo,
      spbhDate: data?.spbhDate,
      spbmNo: data?.spbmNo,
      spbmDate: data?.spbmDate,
      slNo: data?.slNo,
      slDate: data?.slDate,
      noPolKendaraan: data?.noPolKendaraan,
      note: data?.note,
      total: data?.total,
      idSupplier: supplier
        ? {
            label: supplier.supplierName,
            value: supplier.supplierCode,
          }
        : null,
      idSupplierExpedisi: supplierExp
        ? {
            value: supplierExp.supplierCode,
            label: supplierExp.supplierCode,
            name: supplierExp.supplierName,
          }
        : null,
    },
  };
};

export const revertCorrectionHeader = (data, setData) => {
  setData("id", data?.id);
  setData("spbhNo", data?.spbhNo);
  setData("spbhDate", data?.spbhDate);
  setData("spbmNo", data?.spbmNo);
  setData("spbmDate", data?.spbmDate);
  setData("slNo", data?.slNo);
  setData("slDate", data?.slDate);
  setData("noPolKendaraan", data?.noPolKendaraan);
  setData("note", data?.notes);
  setData("total", data?.total);
  setData("idSupplier", data?.idSupplier);
  setData("idSupplierExpedisi", data?.idSupplierExpedisi);
};

export const getCompareGiftPayload = (data) => {
  return data?.map((item) => {
    const { locator, kodeHadiah, jumlah } = item;
    return { locator: locator?.value, kodeHadiah, jumlah };
  });
};

export const checkIsListGiftChange = (origin, modified) => {
  const originPayload = getCompareGiftPayload(origin);
  const modifiedPayload = getCompareGiftPayload(modified);
  return JSON.stringify(originPayload) !== JSON.stringify(modifiedPayload);
};
